





























import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import { Data, Methods, Computed, Props } from "./types";
import { Labels, Key, OmittedEventDetail } from "@/helpers/event-detail-helper";
import { verifyHttp } from "@/helpers/url-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "EventDetailContents",
  components: {
    Heading,
    Body
  },
  props: {
    eventDetail: {
      type: Object as PropType<Props["eventDetail"]>,
      required: true
    },
    company: {
      type: Object as PropType<Props["company"]>,
      required: true
    }
  },
  computed: {
    omittedEventDetail() {
      const filteredKeys = Object.keys(Labels).filter(
        key =>
          // NOTE eventDetailの値がfalsyなkeyを削除する
          !!this.eventDetail[key as keyof Props["eventDetail"]]
      );
      // NOTE id, graduate_year, nameを除外したオブジェクトを返す(表示順はLabelsのkeyの順番)
      return filteredKeys.reduce(
        (obj, key) => ({
          ...obj,
          [key]: this.eventDetail[key as keyof Props["eventDetail"]]
        }),
        {}
      ) as OmittedEventDetail;
    }
  },
  methods: {
    getLabel(key: Key) {
      return Labels[key];
    },
    getVerifiedUrl(url: string) {
      if (verifyHttp(url)) {
        return url;
      }
      return "";
    }
  }
});
